export {default} from './SearchCircleBlue';
